import { useEffect, useState } from 'react'

export function useMobileViewport() {
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight)
      setIsMobile(window.innerWidth < 768)
    }

    // Handle viewport changes on mobile
    const handleViewportChange = () => {
      // Use a small delay to ensure the viewport has settled
      setTimeout(() => {
        setViewportHeight(window.innerHeight)
      }, 100)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleViewportChange)
    
    // Handle mobile browser chrome hiding/showing
    if (isMobile) {
      window.addEventListener('scroll', handleViewportChange, { passive: true })
    }

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleViewportChange)
      if (isMobile) {
        window.removeEventListener('scroll', handleViewportChange)
      }
    }
  }, [isMobile])

  return { viewportHeight, isMobile }
}
